import { render, staticRenderFns } from "./FinalReportComparison.vue?vue&type=template&id=cbf1ff32&scoped=true&"
import script from "./FinalReportComparison.vue?vue&type=script&lang=js&"
export * from "./FinalReportComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf1ff32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VCard,VToolbar,VToolbarTitle})
